'use client';

import Link from 'next/link';

import { IResolvedHelpPage } from '@/src/utils/pages/help.mapper';
import { Button } from '@/src/components/ui/button';
import { generateDataLayerContact } from '@/src/utils/seo/analytics';

export const NeedSupportCard = ({
  title,
  description,
  button,
}: IResolvedHelpPage['needSupport']) => {
  return (
    <div
      className={
        'mx-auto mb-16 flex max-w-1200 flex-col items-center justify-center gap-7 px-4 pt-15 lg:flex-row lg:gap-15'
      }
    >
      <div className={'max-w-[540px] space-y-2'}>
        <div className={'text-4xl font-semibold'}>{title}</div>
        {description}
      </div>
      <Button
        size={'md'}
        className={'self-start font-semibold md:self-center'}
        asChild
      >
        <Link
          className={'no-underline active:bg-primary-dark'}
          href={'mailto:support@gomoworld.com'}
          onClick={() => {
            generateDataLayerContact();
          }}
        >
          {button}
        </Link>
      </Button>
    </div>
  );
};
